import React from "react";
import "./WeatherInfo.css";

export default function WeatherTemperature(props) {
  return (
    <div className="WeatherTemperature">
      <span className="temperature">{Math.round(props.celsius)}</span>
    </div>
  );
}
